<template>
  <BContainer :title="$t('title.reportQuestionsAnswers')">
    <ReportFilter @apply="getQuestionAndAnswers">
      <template v-slot:customButtons>
        <DownloadExcel
          v-if="isExportButtonActive"
          :data="excelData"
          :fields="excelFields"
          :name="`${title}.xls`"
        >
          <button class="button is-link">{{ $t('button.export') }}</button>
        </DownloadExcel>
        <DownloadActionTrackingCalendarButton :answerSetId="answerSetId" v-if="answerSetId && isExportButtonActive" hide-label style="margin-left: 10px;;"/>
      </template>
    </ReportFilter>
    <section class="section b-portlet has-background-light" v-if="tableData">
      <div v-if="isGroup">
        <article
          class="message is-light"
          v-for="answerSet in tableData.answerSets"
          :key="answerSet.id"
        >
          <div class="message-header ">
            <div class="title is-size-5">
              {{ answerSet.process.name }}
            </div>
          </div>
          <div class="message-body">
            <b-table
              :data="answerSet.answers"
              :bordered="true"
              :striped="true"
              :hoverable="true"
              :mobile-cards="true"
            >
              <template slot-scope="props">
                <b-table-column field="no" label="No" width="40" numeric>{{
                  props.row.question.no
                }}</b-table-column>
                <b-table-column field="name" :label="$t('title.question')">
                  {{ props.row.question.name }}
                  <p v-if="props.row.description" class="is-italic has-text-weight-bold">
                    {{ props.row.description }}
                  </p>
                </b-table-column>
                <b-table-column
                  field="answer"
                  width="40"
                  :label="$t('validation.attributes.answer')"
                >
                  <b-button :size="`is-small ${getAnswerClassForPoint(props.row.answerPoint)}`">{{
                    props.row.answerPoint
                  }}</b-button>
                </b-table-column>
              </template>
            </b-table>
          </div>
        </article>
      </div>
      <b-table
        v-else-if="tableData.length > 0"
        :data="tableData"
        :bordered="true"
        :striped="true"
        :hoverable="true"
        :mobile-cards="true"
      >
        <template slot-scope="props">
          <b-table-column field="no" label="No" width="40" numeric>{{
            props.row.no
          }}</b-table-column>
          <b-table-column field="name" :label="$t('title.question')">
            {{ props.row.name }}
            <p v-if="props.row.description" :class="`is-italic ${props.row.hasActionTracking?'has-text-weight-bold':''}`" v-html="props.row.description" />
          </b-table-column>
          <b-table-column field="answer" :label="$t('validation.attributes.answer')">
            <b-tag type="is-success" v-if="props.row.answer === true">{{ $t('button.yes') }}</b-tag>
            <b-tag type="is-danger" v-if="props.row.answer === false">{{ $t('button.no') }}</b-tag>
          </b-table-column>
        </template>
      </b-table>
    </section>
  </BContainer>
</template>
<script>
import ApiService from '../../_api/api.service'
import ReportFilter from './ReportFilter.vue'
import DownloadActionTrackingCalendarButton from '@/components/DownloadActionTrackingCalendarButton.vue'
import DateFilter from '@/_helpers/date.filter'

export default {
  components: { ReportFilter, DownloadActionTrackingCalendarButton },
  data () {
    return {
      tableData: [],
      title: 'report-data',
      excelFields: {},
      excelData: [],
      isExportButtonActive: false,
      isGroup: false,
      answerSetId: null
    }
  },
  mounted () {
    this.excelFields = this.getExcelFields()
  },
  methods: {
    getQuestionAndAnswers (params) {
      const { filter, isGroup } = params
      this.title = filter.content.title
      this.score = null
      this.isGroup = isGroup
      this.answerSetId = filter.answerSetId

      if (isGroup) {
        ApiService.get(`/answerset/group/${filter.answerSetGroupId}/answers`).then(data => {
          this.isExportButtonActive = true
          this.tableData = data
          this.excelData = []
          data.answerSets.forEach(answerSet => {
            this.excelData.push({})
            this.excelData.push({
              name: answerSet.process.name
            })
            answerSet.answers.forEach(answer => {
              this.excelData.push({
                no: answer.question.no,
                name: answer.question.name,
                description: answer.description,
                answer: answer.answerPoint
              })
            })
          })
        })
      } else {
        ApiService.get(`/answerset/${filter.answerSetId}/answers`).then(data => {
          this.isExportButtonActive = true

          this.tableData = data.map(d => {
            const hasActionTracking = d.actionTitle || d.actionAssignors || d.actionDeliveryDate
            const description = hasActionTracking ? `<br/><b>Aksiyon Tanımı:</b> ${d.actionTitle}<br/><b>Atanan Kişi:</b> ${d.actionAssignors}<br/><b>Aksiyon Teslim Tarihi:</b> ${DateFilter.date(d.actionDeliveryDate)}<br/><b>Açıklama:</b> ${d.description}` : `${d.description ? '<br/><b>Açıklama: </b>' + d.description : ''}`
            return {
              no: d.question.no,
              name: d.question.name,
              description,
              answer: d.answer
            }
          }
          )
          this.excelData = data.map(d => {
            const hasActionTracking = d.actionTitle || d.actionAssignors || d.actionDeliveryDate
            const description = hasActionTracking ? `Aksiyon Tanımı: ${d.actionTitle}\nAtanan Kişi: ${d.actionAssignors}\nAksiyon Teslim Tarihi: ${DateFilter.date(d.actionDeliveryDate)}\nAçıklama: ${d.description}` : d.description
            return {
              no: d.question.no,
              name: d.question.name,
              description,
              answer: d.answer === true ? this.$t('button.yes') : this.$t('button.no')
            }
          })
        })
      }
    },
    getExcelFields () {
      const fields = {}
      fields[this.$t('validation.attributes.no')] = 'no'
      fields[this.$t('validation.attributes.question')] = 'name'
      fields[this.$t('validation.attributes.description')] = 'description'
      fields[this.$t('validation.attributes.answer')] = 'answer'
      return fields
    },
    getAnswerClassForPoint (point) {
      switch (point) {
        case 0:
          return 'is-danger'
        case 1:
          return 'is-orange'
        case 2:
          return 'is-gray'
        case 3:
          return 'is-info'
        case 4:
          return 'is-success'
        default:
          return ''
      }
    }
  }
}
</script>
